import { render } from "./phone-icon.svg?vue&type=template&id=1ceac7d2"
import script from "./phone-icon.svg?vue&type=script&lang=js"
export * from "./phone-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2595/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__